import React from "react";
import { ClassNameProps, formatPercentage, makeClassName, StyleProps } from "@hex-insights/core";
import { ContractUtilities } from "../../../Utilities";
import styles from "./styles.module.css";

export type ContractPaymentProgressDonutProps = {
	paymentProgress: ContractUtilities.PaymentProgressInformation;
	size?: string;
} & Partial<ClassNameProps & StyleProps>;

export function ContractPaymentProgressDonut({
	paymentProgress,
	size = "5.5rem",
	className,
	style,
}: ContractPaymentProgressDonutProps) {
	const { totalPrice, amountPaid, amountDue, amountOverdue, amountUpcoming } = paymentProgress;

	const background = React.useMemo(() => {
		if (totalPrice === 0) {
			return "var(--neutral-colors--light)";
		}

		const slices = [];
		let cumulativeValue = 0;
		const data = [
			{
				value: amountPaid,
				color: "var(--theme-colors__green)",
			},
			{
				value: amountOverdue,
				color: "var(--theme-colors__orange)",
			},
			{
				value: amountDue,
				color: "var(--theme-colors__yellow)",
			},
			{
				value: amountUpcoming,
				color: "var(--neutral-colors--light)",
			},
		];
		for (let i = 0; i < data.length; i++) {
			const datum = data[i];
			cumulativeValue += datum.value;
			slices.push(`${datum.color} 0 ${(cumulativeValue / totalPrice) * 100}%`);
		}
		return `conic-gradient(${slices.join(", ")})`;
	}, [totalPrice, amountPaid, amountDue, amountOverdue, amountUpcoming]);

	return (
		<div
			className={makeClassName(styles["payment-progress"], className)}
			style={{ background, "--donut-size": size, ...style } as React.CSSProperties}
		>
			<span
				className={makeClassName(
					styles["payment-progress__percentage"],
					amountPaid > 0 ? styles["payment-progress__percentage--non-zero"] : "",
				)}
			>
				{formatPercentage(amountPaid / totalPrice, { precision: 0 })}
			</span>
		</div>
	);
}
